import React from "react";
import styles from "./Subscribe.module.scss";

const Subscribe = () => {
  return (
    <div className={styles.container}>
      <input type="text" placeholder="Email address.." />
      <button>Subscibe Now</button>
    </div>
  );
};

export default Subscribe;
